export default {
  root: {
    cursor: 'pointer',
    '&:hover': {},
  },
};
